// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"d01bff2a0e513a724ed4","276":"5b81e2a9b37b95229a92"}[chunkId] + ".js";
};